import React from 'react';
import { Slide } from 'react-reveal';
import { connect } from 'react-redux';
import * as Actions from '../../../state/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { paramsToObject } from '../../../Utils';
import style from './style.module.scss';

const ProductSection = props => {
    const { product = {} } = props;
    const { name = 'No Name Available', details = 'No details available for this product', photos = [] } = product;
    let productPhoto = photos.find(p => p.photo_type_id === 1);
    let { location = '' } = productPhoto || {};
    const nutritionalImage = photos.reduce((f, c) => c.photo_type_id === 2 ? c : f, null)

    const handleNutritionalFactsClick = (e) => {
        e.preventDefault();
        props.dispatch({ type: Actions.SET_NUTRI_FACTS_IMAGE, src: nutritionalImage })
        props.dispatch({ type: Actions.TOGGLE_NUTRITION, bool: true })
    }

    return (
        <div className={style.wrapper}>
            <Slide left>
                <div className={style.productImage}>
                    {location && <img src={location} />}
                </div>
            </Slide>
            <Slide right>
                <div className={style.productInfo}>
                    <h1>{name}</h1>
                    <p>{details || 'No details available for this product'}</p>
                    {nutritionalImage && <button onClick={handleNutritionalFactsClick}><span>Nutritional Info</span><FontAwesomeIcon icon={"arrow-right"} /></button>}
                </div>
            </Slide>
        </div>
    );
};

ProductSection.propTypes = {

};

export default connect(state => {
    const { search = "" } = window.location;
    const queryParams = paramsToObject(search);
    const viewedProduct = state.products.find(p => p.id === +queryParams.id);
    return {
        product: viewedProduct
    }
})(ProductSection);